// import React, { useState, useEffect } from "react";
// import { toast } from "react-hot-toast";
// import { useNavigate } from "react-router-dom";
// import { X } from "lucide-react";

// import { AcceptDialog } from "../../components/Elements/DialogBox/AcceptDialog";
// import { ReactComponent as Arrow } from "../../assets/svgs/arrow.svg";
// import { postApi } from "../../api/api_instance";
// import { API_URLS } from "../../api/apiUrls";
// import PopupCard from "./PopupCard";
// const ResetPasswords = ({ onCloseReset }) => {
//   const navigate = useNavigate();
//   // State management
//   const [email, setEmail] = useState("");
//   const [isLoading, setIsLoading] = useState(false);
//   const [emailSentPopup, setEmailSentPopup] = useState(false);
//   const [emailNotSentPopup, setEmailNotSentPopup] = useState(false);
//   const [showPopup, setShowPopup] = useState(false);
//   const [popupData, setPopupData] = useState({
//     type: "success",
//     title: "Success",
//     message: "",
//   });
//   const triggerPopup = (type, title, message, duration = 5000) => {
//     setPopupData({ type, title, message });
//     setShowPopup(true);
//     setTimeout(() => setShowPopup(false), duration);
//   };
//   // Form validation
//   const [errors, setErrors] = useState({});

//   // Email validation helper
//   const validateEmail = (email) => {
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     return emailRegex.test(email);
//   };

//   // Handle form validation
//   const validateForm = () => {
//     const newErrors = {};

//     if (!email.trim()) {
//       newErrors.email = "Email is required";
//     } else if (!validateEmail(email)) {
//       newErrors.email = "Please enter a valid email address";
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   // Handle email input change
//   const handleEmailChange = (e) => {
//     const value = e.target.value;
//     setEmail(value);

//     // Clear error when user starts typing
//     if (errors.email) {
//       setErrors((prev) => ({ ...prev, email: "" }));
//     }
//   };

//   // Handle form submission
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateForm()) return;

//     setIsLoading(true);

//     try {
//       const response = await postApi(
//         {
//           apiUrl: API_URLS.FORGOT_PASSWORD,
//           data: { email: email.trim() },
//         },
//         false,
//       );

//       if (response.success) {
//         setEmailSentPopup(true);
//         toast.success("Password reset email sent successfully!");
//       } else {
//         throw new Error(response.message || "Failed to send reset email");
//       }
//     } catch (error) {
//       console.error("Password reset error:", error);
//       setEmailNotSentPopup(true);
//       toast.error(
//         error.message || "Failed to send reset email. Please try again.",
//       );
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   // Handle successful email sent redirect
//   useEffect(() => {
//     if (emailSentPopup) {
//       const timer = setTimeout(() => {
//         setEmailSentPopup(false);
//         navigate("/organization/login");
//       }, 2000);

//       return () => clearTimeout(timer);
//     }
//   }, [emailSentPopup, navigate]);

//   // Handle closing email not sent popup
//   const handleCloseErrorPopup = () => {
//     setEmailNotSentPopup(false);
//   };

//   return (
//     <>
//       {/* Main Modal */}
//       <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
//         <div className="bg-white py-6 px-6 shadow-lg rounded-lg sm:px-8 w-full max-w-md relative">
//           {/* Header Buttons */}
//           <div className="flex justify-end items-center mb-4">
//             {/* Back Button */}
//             {/* <button
//               onClick={() => navigate(-1)}
//               className="flex items-center text-gray-500 hover:text-gray-700 transition-colors"
//             >
//               <Arrow className="w-5 h-5 lg:w-6 lg:h-6 mr-2" />
//               <span className="text-sm lg:text-base font-light">Back</span>
//             </button> */}

//             {/* Close Button */}
//             <button
//               onClick={onCloseReset}
//               className="text-gray-500 hover:text-gray-700 transition-colors"
//               aria-label="Close modal"
//             >
//               <X className="w-5 h-5" />
//             </button>
//           </div>

//           {/* Header */}
//           <div className="text-center mb-6">
//             <h2 className="text-2xl font-bold text-[#06513D] mb-1">CARBURN</h2>
//             <p className="text-sm text-gray-600 mb-4">
//               Carbon Footprint & ESG Reporting
//             </p>

//             <h3 className="text-xl font-semibold text-[#06513D] mb-2">
//               Forgot Password
//             </h3>
//             <p className="text-sm text-gray-600">
//               Enter your registered email address. We'll send you a link to
//               reset your password.
//             </p>
//           </div>

//           {/* Form */}
//           <form onSubmit={handleSubmit} className="space-y-4">
//             <div>
//               <label
//                 htmlFor="email"
//                 className="block text-sm font-medium text-gray-700 mb-1"
//               >
//                 Email Address
//               </label>
//               <input
//                 id="email"
//                 name="email"
//                 type="email"
//                 required
//                 className={`appearance-none block w-full px-3 py-2 border rounded-md placeholder-gray-400 focus:outline-none sm:text-sm transition-colors ${errors.email
//                     ? "border-red-300 focus:border-red-500"
//                     : "border-gray-300 focus:border-[#06513D]"
//                   }`}
//                 placeholder="your@email.com"
//                 value={email}
//                 onChange={handleEmailChange}
//                 disabled={isLoading}
//               />
//               {errors.email && (
//                 <p className="mt-1 text-sm text-red-600">{errors.email}</p>
//               )}
//             </div>

//             {/* Submit Button */}
//             <button
//               type="submit"
//               disabled={isLoading}
//               className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#06513D] hover:bg-[#054a35] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#06513D] disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
//             >
//               {isLoading ? (
//                 <span className="flex items-center">
//                   <svg
//                     className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
//                     xmlns="http://www.w3.org/2000/svg"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                   >
//                     <circle
//                       className="opacity-25"
//                       cx="12"
//                       cy="12"
//                       r="10"
//                       stroke="currentColor"
//                       strokeWidth="4"
//                     ></circle>
//                     <path
//                       className="opacity-75"
//                       fill="currentColor"
//                       d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                     ></path>
//                   </svg>
//                   Sending...
//                 </span>
//               ) : (
//                 "Get Password Reset Link"
//               )}
//             </button>
//           </form>
//         </div>
//       </div>

//       {/* Success Popup */}
//       {emailSentPopup && (
//         <AcceptDialog
//           title="Email Sent Successfully!"
//           message="Please check your email for the password reset link."
//           onAccept={() => setEmailSentPopup(false)}
//           acceptText="OK"
//         />
//       )}

//       {/* Error Popup */}
//       {emailNotSentPopup && (
//         <AcceptDialog
//           title="Email Not Sent"
//           message="There was an error sending the reset email. Please try again."
//           onAccept={handleCloseErrorPopup}
//           acceptText="OK"
//         />
//       )}
//     </>
//   );
// };

// export default ResetPasswords;
import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { X } from "lucide-react";

import { ReactComponent as Arrow } from "../../assets/svgs/arrow.svg";
import { postApi } from "../../api/api_instance";
import { API_URLS } from "../../api/apiUrls";
import PopupCard from "./PopupCard";
import ResetPasswordToken from "./ResetPasswordToken";

const ResetPasswords = ({ onCloseReset }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  // State management
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});

  // Popup state - exactly like signup component
  const [showPopup, setShowPopup] = useState(false);
  const [popupData, setPopupData] = useState({
    type: "success",
    title: "Success",
    message: "",
  });

  // AcceptDialog states
  const [emailSentPopup, setEmailSentPopup] = useState(false);
  const [emailNotSentPopup, setEmailNotSentPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  // Auto-close popups
  useEffect(() => {
    if (emailSentPopup) {
      const timer = setTimeout(() => {
        setEmailSentPopup(false);
        if (onCloseReset) {
          onCloseReset();
        }
        navigate("/organization/login");
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [emailSentPopup, navigate, onCloseReset]);

  useEffect(() => {
    if (emailNotSentPopup) {
      const timer = setTimeout(() => {
        setEmailNotSentPopup(false);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [emailNotSentPopup]);

  const triggerPopup = (type, title, message, duration = 5000) => {
    setPopupData({ type, title, message });
    setShowPopup(true);
    setTimeout(() => setShowPopup(false), duration);
  };

  // Email validation helper
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Handle input change - like signup component
  const handleChange = (e) => {
    const value = e.target.value;
    setEmail(value);

    // Clear error when user starts typing
    if (errors.email) {
      setErrors((prev) => ({ ...prev, email: "" }));
    }
  };

  // Handle form submission - like signup component pattern
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation with popup - like signup component
    if (!email.trim()) {
      return triggerPopup("error", "Error", "Please enter your email address.");
    }

    if (!validateEmail(email)) {
      return triggerPopup(
        "error",
        "Error",
        "Please enter a valid email address.",
      );
    }

    setIsLoading(true);

    try {
      const response = await postApi({
        apiUrl: API_URLS.FORGOT_PASSWORD,
        data: { email: email.trim() },
      });

      if (response.success) {
        setEmailSentPopup(true);
      } else {
        setErrorMessage(response.message || "Failed to send reset email.");
        setEmailNotSentPopup(true);
      }
    } catch (error) {
      setErrorMessage(
        error.message || "Failed to send reset email. Please try again.",
      );
      setEmailNotSentPopup(true);
    } finally {
      setIsLoading(false);
    }
  };

  if (token) {
    return <ResetPasswordToken />;
  }

  return (
    <>
      {/* Main Modal */}
      {!emailSentPopup && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white py-6 px-6 shadow-lg rounded-lg sm:px-8 w-full max-w-md relative">
            {/* Header Buttons */}
            <div className="flex justify-end items-center mb-4">
              {/* Close Button */}
              <button
                onClick={onCloseReset}
                className="text-gray-500 hover:text-gray-700 transition-colors"
                aria-label="Close modal"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            {/* Header */}
            <div className="text-center mb-6">
              <h2 className="text-2xl font-bold text-[#06513D] mb-1">
                CARBURN
              </h2>
              <p className="text-sm text-gray-600 mb-4">
                Carbon Footprint & ESG Reporting
              </p>

              <h3 className="text-xl font-semibold text-[#06513D] mb-2">
                Forgot Password
              </h3>
              <p className="text-sm text-gray-600">
                Enter your registered email address. We'll send you a link to
                reset your password.
              </p>
            </div>

            {/* Form */}
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  Email Address
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  required
                  className={`appearance-none block w-full px-3 py-2 border rounded-md placeholder-gray-400 focus:outline-none sm:text-sm transition-colors ${
                    errors.email
                      ? "border-red-300 focus:border-red-500"
                      : "border-gray-300 focus:border-[#06513D]"
                  }`}
                  placeholder="your@email.com"
                  value={email}
                  onChange={handleChange}
                  disabled={isLoading}
                />
                {errors.email && (
                  <p className="mt-1 text-sm text-red-600">{errors.email}</p>
                )}
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                disabled={isLoading}
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#06513D] hover:bg-[#054a35] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#06513D] disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
              >
                {isLoading ? (
                  <span className="flex items-center">
                    <svg
                      className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    Sending...
                  </span>
                ) : (
                  "Get Password Reset Link"
                )}
              </button>
            </form>
          </div>
        </div>
      )}

      {/* Popup - exactly like signup component */}
      {showPopup && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
          <PopupCard
            type={popupData.type}
            title={popupData.title}
            message={popupData.message}
          />
        </div>
      )}

      {emailSentPopup && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
          <PopupCard
            type="success"
            title="Reset Link Sent"
            message="Please check your inbox for the password reset link."
          />
        </div>
      )}

      {emailNotSentPopup && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
          <PopupCard
            type="error"
            title="Email Not Sent"
            message={errorMessage}
          />
        </div>
      )}
    </>
  );
};

export default ResetPasswords;
